import React from 'react';
import Label from 'components/_utility/Label';
import { getImageBaseUrl } from 'helpers/request';
import InfoCircle from 'src/assets/icons/info-circle.svg';
import { setSelectedDisclaimer, openModal, closeModal } from 'src/redux/configurator/actions';
import { showPriceDisclaimerSelector, getGoalId } from 'src/redux/app/selectors';
import { useDispatch, useSelector } from 'react-redux';
import fetchGoal from 'helpers/goals';

import {
  Wrap,
  ImageWrap,
  Image,
  Content,
  Name,
  PriceWrapper,
  Price,
  InfoCircleWrap,
  Description,
  Actions,
  Action,
  ActionLink,
  Divider,
  MainContent,
  AdditionalContent,
  DetailedDescription,
} from './BikeCard.styled';

export const BikeCard = ({
  className,
  bike: { id, name, thumbnail, priceLocalised, pricePrefixText, description, detailDescription, url },
  family = false,
  isListingsPage = false,
  listView = false,
  ...props
}) => {
  const dispatch = useDispatch();
  const showPriceDisclaimer = useSelector(showPriceDisclaimerSelector);
  const priceDisclaimerWrapper = document.getElementById('price-disclaimer-wrapper');
  return (
    <Wrap className={className} isListingsPage={isListingsPage} listView={listView} {...props}>
      <MainContent listView={listView}>
        <ImageWrap to={family ? `/bikes/family/${id}` : `/bike/${id}/configure`} listView={listView}>
          {thumbnail ? <Image src={getImageBaseUrl() + thumbnail.src} alt={thumbnail.alt} /> : null}
        </ImageWrap>
        <Content isListingsPage={isListingsPage} listView={listView}>
          <Name dangerouslySetInnerHTML={{ __html: name }} listView={listView} />
          <PriceWrapper listView={listView}>
            <Price listView={listView}>
              {pricePrefixText || <Label name="fromLabel" />} {priceLocalised}
            </Price>
            {showPriceDisclaimer && priceDisclaimerWrapper && (
              <InfoCircleWrap
                onClick={() => {
                  dispatch(setSelectedDisclaimer('price-disclaimer'));
                  dispatch(openModal('disclaimer'));
                }}
              >
                <InfoCircle />
              </InfoCircleWrap>
            )}
          </PriceWrapper>
          <Description dangerouslySetInnerHTML={{ __html: description }} isListingsPage={isListingsPage} />
        </Content>
      </MainContent>
      <AdditionalContent listView={listView}>
        <DetailedDescription
          listView={listView}
          dangerouslySetInnerHTML={{ __html: detailDescription }}
        ></DetailedDescription>
        <Actions>
          <Action onClick to={family ? `/bikes/family/${id}` : `/bike/${id}/configure`} primary>
            <Label name="configureLabel" />
          </Action>
          <Divider />
          <ActionLink href={url}>
            <Label name="viewDetailsLabel" />
          </ActionLink>
        </Actions>
      </AdditionalContent>
    </Wrap>
  );
};

export default BikeCard;
